function EmptyDiary() {
	return <div></div>;
}

export default EmptyDiary;
